'use client'

import { Box, Text } from '@mantine/core'
import { useTranslations } from 'next-intl'

import { AllAvailableCurrencyCodes } from '@/types/currency'

interface StockConverterHeaderProps {
  coinSymbol: string
  coinName: string
  currency: AllAvailableCurrencyCodes
  currencyName: string
}

export function StockConverterHeader({
  coinSymbol,
  coinName,
  currency,
  currencyName,
}: StockConverterHeaderProps) {
  const tConverter = useTranslations('converter')

  return (
    <Box>
      <Text component="h2" fz={32} fw={600} lh="40px" lts={'-0.48px'}>
        {coinSymbol} to {currency}
      </Text>
      <Text component="h1" fz={16} fw={600} c="var(--content-secondary)">
        {tConverter('convertTitle', {
          coinName,
          symbol: coinSymbol,
          fiatName: currencyName,
          currency: `(${currency})`,
        })}
      </Text>
    </Box>
  )
}
